import ReceptionsManager from "@features/achats/components/receptions/ReceptionsManager";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Inbox } from "lucide-react";

export const Route = createFileRoute("/_app/achats/receptions/")({
  staticData: {
    title: "Réceptions",
    icon: Inbox,
    tab_icon: Inbox,
    permission: PERMISSIONS.ACHATS.RECEPTIONS.VIEW,
    module: "achats",
    order: 50,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
  },
  component: ReceptionsManager,
});
